"use client";

import React from "react";
import { ArrowRight, Activity, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ControlTotalEnVia() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const backgroundImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/precision_cnc_machining_center.png",
    delay: "0s"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/industrial_lathe_metal_turning.png",
    delay: "5s"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/heavy_duty_gear_fabrication.png",
    delay: "10s"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/custom_steel_component_manufacturing.png",
    delay: "15s"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/on_site_industrial_milling.png",
    delay: "20s"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/advanced_cnc_milling_process.png",
    delay: "25s"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/mechanical_part_repair_service.png",
    delay: "30s"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/precision_engineering_measurements.png",
    delay: "35s"
  }, {
    src: "https://mivgrupo.com/wp-content/uploads/2026/04/Techs_MIV_HE_Tiny.jpg",
    delay: "40s"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/automated_metal_fabrication_line.png",
    delay: "45s"
  }];
  return <section data-section-id="73063" id="inicio" className="dark bg-background text-foreground relative overflow-hidden min-h-[500px] md:min-h-[700px] lg:min-h-[800px] flex items-center pt-20 pb-10 md:pt-28 md:pb-12 !h-auto lg:!h-[800px] lg:py-24 !">
      <style>{`
        @keyframes float-device {
          0%, 100% { transform: translateY(0) rotate(-1deg); }
          50% { transform: translateY(-15px) rotate(1deg); }
        }
        .animate-float-device {
          animation: float-device 6s ease-in-out infinite;
        }
        @keyframes fade-bg {
          0%, 100% { opacity: 0; }
          2%, 10% { opacity: 1; }
          12% { opacity: 0; }
        }
        .animate-fade-bg {
          animation: fade-bg 50s infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {backgroundImages.map((img, i) => <div key={i} data-index={i} className="absolute inset-0 bg-cover bg-center opacity-0 blur-[4px] scale-110 animate-fade-bg" style={{
        backgroundImage: `url(${img.src})`,
        animationDelay: img.delay
      }} />)}
        <div className="absolute inset-0 bg-black/20 pointer-events-none" />
      </div>

      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none">
        <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(to right, var(--color-foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--color-foreground) 1px, transparent 1px)`,
        backgroundSize: "60px 60px",
        maskImage: "radial-gradient(ellipse 80% 50% at 50% 50%, black 40%, transparent 100%)",
        WebkitMaskImage: "radial-gradient(ellipse 80% 50% at 50% 50%, black 40%, transparent 100%)"
      }} />
      </div>

      {}
      <div className="absolute inset-0 z-0 opacity-[0.06] pointer-events-none bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/industrial_workshop_precision_watermark.png)]" />
      
      {}
      <div className="absolute inset-0 z-0 bg-black/20 pointer-events-none" />

      {}
      <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] md:w-[500px] md:h-[500px] bg-primary/5 rounded-full blur-[80px] md:blur-[120px] pointer-events-none z-0" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">
          
          {}
          <div ref={leftColRef} className={`lg:col-span-7 flex flex-col items-center lg:items-start justify-center transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            
            <div className="bg-black/40 lg:bg-transparent p-5 md:p-8 lg:p-0 rounded-lg backdrop-blur-sm lg:backdrop-blur-none w-full flex flex-col items-center lg:items-start">
              <h1 className="font-default font-extrabold tracking-tighter leading-tight md:leading-[1.1] mb-4 md:mb-6 uppercase text-center !font-sans !text-[hsl(202,80%,24%)] text-2xl md:text-4xl lg:text-5xl lg:text-left">MECANIZADO INDUSTRIAL DE PRECISIÓN PARA SECTORES ESTRATEGICOS</h1>

              <p className="max-w-2xl mb-6 md:mb-10 my-4 md:my-8 leading-relaxed md:leading-loose font-default !font-extrabold text-base sm:text-xl md:text-2xl !text-[hsl(210,14%,89%)] text-center lg:text-left">Fabricación metalmecánica, rebabitado de cojinetes, reparación de cajas reductoras y mecanizado en sitio (In-situ).<div className="!h-[10px] md:!h-[25px]" data-ast-id="f:/src/pages/Home/sections/ControlTotalEnVia.tsx|sig:h6oerw" data-ast-start="5438" data-ast-end="5606"><br /></div><div data-ast-id="f:/src/pages/Home/sections/ControlTotalEnVia.tsx|sig:o0jwpi" data-ast-start="5606" data-ast-end="5881" className="!text-[hsl(200,98%,39%)]">Componentes industriales de precisión micrométrica para petróleo, gas, petroquímica, naval e industria pesada en Venezuela.</div></p>

              <div className="flex flex-col sm:flex-row gap-4 md:gap-6 items-center lg:items-start w-full">
                <Link to="/#formulario-cotizacion-industrial" className="w-[95%] sm:w-auto mx-auto lg:mx-0">
                  <Button size="lg" className="bg-primary inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 w-full h-12 md:h-16 px-6 md:px-8 text-sm sm:text-lg font-default font-bold rounded-sm text-primary-foreground shadow-[0_4px_20px_rgba(249,115,22,0.3)] transition-all uppercase !bg-[hsl(38,92%,50%)] !text-center disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:shadow-[0_6px_30px_rgba(249,115,22,0.5)]">SOLICITAR COTIZACIÓN INDUSTRIAL</Button>
                </Link>
              </div>

              <div className="mt-8 md:mt-12 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 md:gap-8 text-xs sm:text-sm font-mono text-muted-foreground">
                <div className="flex items-center gap-3">
                  <Activity className="size-5 sm:size-6 text-primary" />
                  <span className="text-center sm:text-left">Tolerancia a Nivel Micrométrico</span>
                </div>
                <div className="flex items-center gap-3">
                  <ShieldCheck className="size-5 sm:size-6 text-primary" />
                  <span className="text-center sm:text-left">Servicio En Sitio 24/7</span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={rightColRef} className={`lg:col-span-5 relative mt-10 md:mt-16 lg:mt-0 transition-all duration-1000 delay-300 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="relative w-full max-w-[240px] sm:max-w-[350px] lg:max-w-[500px] mx-auto aspect-[3/4] lg:aspect-[3/4]">
              {}
              <div className="absolute inset-0 rounded-sm overflow-hidden border border-border/20 shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent z-10" />
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/cnc_milling_high_res.png" alt="Proceso de mecanizado CNC de alta precisión" className="w-full h-full object-cover scale-105 hover:scale-100 transition-transform duration-1000" />
              </div>

              {}
              <div className="absolute -left-4 sm:-left-12 lg:-left-16 top-1/4 w-[120px] sm:w-[200px] lg:w-[280px] z-20 animate-float-device">
                <div className="relative rounded-sm border-[3px] sm:border-[4px] lg:border-[6px] border-secondary bg-secondary shadow-2xl overflow-hidden aspect-[9/16]">
                  {}
                  <div className="absolute top-0 inset-x-0 h-2 sm:h-4 bg-secondary z-30 w-1/3 mx-auto" />
                  
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1632165/img/miv_technical_spec.png" alt="Especificaciones técnicas de fabricación industrial" className="w-full h-full object-cover" />
                  
                  {}
                  <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-white/10 pointer-events-none" />
                </div>
                
                {}
                <div className="absolute -bottom-4 sm:-bottom-8 left-1/2 -translate-x-1/2 w-3/4 h-3 sm:h-6 bg-black/60 blur-xl rounded-full z-10" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}